import React, { useState, useEffect } from "react";
import { Save, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { useContent } from "../context/ContentContext";
import ImageUpload from "./ImageUpload";

const TEXT_FIELDS = [
  { group: "Página Inicial (Hero)", fields: [
    { key: "hero_subtitle_pt", label: "Subtítulo (PT)" },
    { key: "hero_subtitle_en", label: "Subtítulo (EN)" },
    { key: "hero_desc_pt", label: "Descrição (PT)", area: true },
    { key: "hero_desc_en", label: "Descrição (EN)", area: true },
  ]},
  { group: "Estatísticas", fields: [
    { key: "stat_years", label: "Anos de Experiência" },
    { key: "stat_tuned", label: "Suspensões Afinadas" },
    { key: "stat_dedication", label: "Dedicação" },
  ]},
  { group: "História (About)", fields: [
    { key: "about_founder_pt", label: "Fundador (PT)" },
    { key: "about_founder_en", label: "Fundador (EN)" },
    { key: "about_p1_pt", label: "Parágrafo 1 (PT)", area: true },
    { key: "about_p1_en", label: "Parágrafo 1 (EN)", area: true },
    { key: "about_p2_pt", label: "Parágrafo 2 (PT)", area: true },
    { key: "about_p2_en", label: "Parágrafo 2 (EN)", area: true },
  ]},
  { group: "Contactos", fields: [
    { key: "contact_address", label: "Morada (curta)" },
    { key: "contact_address_full", label: "Morada (completa)" },
    { key: "contact_phone", label: "Telefone" },
    { key: "contact_email", label: "Email" },
    { key: "contact_hours", label: "Horário" },
  ]},
  { group: "WhatsApp", fields: [
    { key: "whatsapp_number", label: "Número WhatsApp (com indicativo)" },
    { key: "whatsapp_message", label: "Mensagem inicial" },
  ]},
];

const ContentManager = () => {
  const { refresh } = useContent();
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { api.getContent().then(setForm).catch(() => {}); }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      await api.updateContent(form);
      await refresh();
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { alert("Erro ao guardar."); }
    finally { setSaving(false); }
  };

  const inputCls = "bf-input w-full rounded-xl px-4 py-2.5 text-sm placeholder:text-gray-500";
  const labelCls = "block text-xs font-medium text-gray-400 mb-1.5";

  return (
    <div className="max-w-4xl">
      <div className="flex items-center justify-between mb-6 sticky top-[76px] z-20 bg-[#070b18]/80 backdrop-blur py-2">
        <p className="text-gray-400 text-sm">Editar textos, contactos e imagens do site</p>
        <button onClick={save} disabled={saving} className="bf-btn-primary text-white font-semibold px-6 py-2.5 rounded-xl inline-flex items-center gap-2 text-sm disabled:opacity-60">
          {saved ? <CheckCircle2 className="w-4 h-4" /> : <Save className="w-4 h-4" />}
          {saving ? "A guardar..." : saved ? "Guardado!" : "Guardar Alterações"}
        </button>
      </div>

      {/* Images */}
      <div className="bf-glass rounded-2xl p-6 mb-6">
        <h3 className="text-white font-bold mb-4">Imagens</h3>
        <div className="grid md:grid-cols-2 gap-6">
          <ImageUpload value={form.logo_image} onChange={(url) => set("logo_image", url)} label="Logótipo (navbar/rodapé)" />
          <ImageUpload value={form.banner_image} onChange={(url) => set("banner_image", url)} label="Banner da Página Inicial" />
        </div>
        <p className="text-gray-500 text-xs mt-3">Deixe vazio para usar as imagens predefinidas.</p>
      </div>

      {/* Text groups */}
      {TEXT_FIELDS.map((grp) => (
        <div key={grp.group} className="bf-glass rounded-2xl p-6 mb-6">
          <h3 className="text-white font-bold mb-4">{grp.group}</h3>
          <div className="grid md:grid-cols-2 gap-4">
            {grp.fields.map((f) => (
              <div key={f.key} className={f.area ? "md:col-span-2" : ""}>
                <label className={labelCls}>{f.label}</label>
                {f.area ? (
                  <textarea rows={2} value={form[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} className={inputCls} />
                ) : (
                  <input value={form[f.key] || ""} onChange={(e) => set(f.key, e.target.value)} className={inputCls} />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="flex justify-end pb-4">
        <button onClick={save} disabled={saving} className="bf-btn-primary text-white font-semibold px-6 py-3 rounded-xl inline-flex items-center gap-2 text-sm disabled:opacity-60">
          <Save className="w-4 h-4" /> {saving ? "A guardar..." : "Guardar Alterações"}
        </button>
      </div>
    </div>
  );
};

export default ContentManager;
